
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const isLoggedIn = () => !!localStorage.getItem("access_token");

const ProtectedRoute = () => {
  return isLoggedIn() ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
